module.exports = "/assets/data/fb7a296f470389bc57de2c60c2c4b976-LS5.data.json";